import { ChangeEvent } from "react";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { ExpressContactKind } from "../../types/express-master.type";
import { ALL } from "../CreditDebitNote/constants";
import {
  ACTIVE_FILTER_OPTIONS,
  ActiveFilter,
  CONTACT_KIND_FILTER,
  MASTER_SEARCH_MAX_LENGTH,
} from "./constants";

export interface MasterFilterValue {
  search: string;
  status: ActiveFilter;
  /** The contacts list only. */
  kind: ExpressContactKind | typeof ALL;
}

export const EMPTY_MASTER_FILTER: MasterFilterValue = { search: "", status: ALL, kind: ALL };

interface MasterFilterProps {
  value: MasterFilterValue;
  hasKind: boolean;
  onChange: (patch: Partial<MasterFilterValue>) => void;
}

const searchSlotProps = {
  htmlInput: { maxLength: MASTER_SEARCH_MAX_LENGTH },
  input: {
    startAdornment: (
      <InputAdornment position="start">
        <SearchIcon fontSize="small" />
      </InputAdornment>
    ),
  },
};

/** Search on the code or name, the active switch and, for contacts, the kind. */
export default function MasterFilter({ value, hasKind, onChange }: Readonly<MasterFilterProps>) {
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) =>
    onChange({ search: event.target.value });
  const handleStatusChange = (event: ChangeEvent<HTMLInputElement>) =>
    onChange({
      status: ACTIVE_FILTER_OPTIONS.find((option) => option.value === event.target.value)?.value ?? ALL,
    });
  const handleKindChange = (event: ChangeEvent<HTMLInputElement>) =>
    onChange({
      kind: CONTACT_KIND_FILTER.find((option) => option.value === event.target.value)?.value ?? ALL,
    });

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: hasKind ? 6 : 8 }}>
        <TextField
          size="small"
          fullWidth
          label="ค้นหา"
          placeholder="รหัส / ชื่อ"
          value={value.search}
          onChange={handleSearchChange}
          slotProps={searchSlotProps}
        />
      </Grid>
      {hasKind && (
        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
          <TextField select size="small" fullWidth label="ประเภท" value={value.kind} onChange={handleKindChange}>
            {CONTACT_KIND_FILTER.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      )}
      <Grid size={{ xs: 12, sm: 6, md: hasKind ? 3 : 4 }}>
        <TextField select size="small" fullWidth label="สถานะ" value={value.status} onChange={handleStatusChange}>
          {ACTIVE_FILTER_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  );
}
